export default "__VITE_ASSET__6b56e87a__"